import { Reducer } from 'redux';
import produce from 'immer';

import { UserState, UserTypes } from './types';
import { AuthTypes } from '../auth/types';

const INITIAL_STATE: UserState = {
  user: {
    userId: '',
    name: '',
    phone: '',
    email: '',
    isActive: false,
    isAdmin: false,
    hasCompletedTour: false,
    hasDemoData: false,
    createdAt: '',
    config: {
      tradeInWeekend: true,
      goalOfMonth: 500,
      currency: 'BRL',
      stopWin: 0,
      stopLoss: 0,
      instruments: [
        { name: 'Opções Binárias', shortName: 'OB', isDefault: true },
        { name: 'Forex', shortName: 'FX', isDefault: false },
        { name: 'Mini Índice', shortName: 'MI', isDefault: false }
      ],
      assets: [
        { name: 'EUR/USD', isDefault: true },
        { name: 'Ouro', isDefault: false },
      ],
      tags: ['Tendência', 'Reversão', 'Notícias'],
    },
  },
};

const auth: Reducer<UserState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case AuthTypes.SIGN_IN_SUCCESS:
      return produce(state, draft => {
        draft.user = action.payload.user;
        if (!draft.user.config.tags || draft.user.config.tags.length === 0) {
          draft.user.config.tags = INITIAL_STATE.user.config.tags;
        }
      });
    case UserTypes.USER_CHANGE:
      return produce(state, draft => {
        draft.user.name = action.payload.name;
        draft.user.phone = action.payload.phone;
        draft.user.config.goalOfMonth = action.payload.goal;
        draft.user.config.currency = action.payload.currency;
        draft.user.config.stopWin = action.payload.stopWin;
        draft.user.config.stopLoss = action.payload.stopLoss;
      });
    case UserTypes.UPDATE_INSTRUMENTS_SUCCESS:
      return produce(state, draft => {
        draft.user.config.instruments = action.payload.instruments;
      });
    case UserTypes.UPDATE_ASSETS_SUCCESS:
      return produce(state, draft => {
        draft.user.config.assets = action.payload.assets;
      });
    case UserTypes.UPDATE_TAGS_SUCCESS:
      return produce(state, draft => {
        draft.user.config.tags = action.payload.tags;
      });
    case UserTypes.COMPLETE_TOUR:
      return produce(state, draft => {
        draft.user.hasCompletedTour = true;
      });
    case UserTypes.LOAD_DEMO_DATA:
      return produce(state, draft => {
        draft.user.hasDemoData = true;
      });
    case UserTypes.CLEAR_DEMO_DATA:
      return produce(state, draft => {
        draft.user.hasDemoData = false;
      });
    case AuthTypes.LOGOUT: {
      return produce(state, draft => {
        draft.user = INITIAL_STATE.user;
      });
    }
    default:
      return state;
  }
};

export default auth;
